import React from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import LeftMenuDesktop from './LeftMenuDesktop';

export default ({ children, ...props }) => {

  return (
    <>
      <BrowserView>
        <div className="row pt-32 pb-32">
          <div className="col-xs-4">
            <LeftMenuDesktop {...props} />
          </div>
          <div className="col-xs-8">
            {children}
          </div>
        </div>
      </BrowserView>
      <MobileView>{children}</MobileView>
    </>
  );
};
